import * as React from 'react';

function SvgIconNotAccept(props) {
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7 .875a6.125 6.125 0 100 12.25A6.125 6.125 0 007 .876zm2.261 8.452l-.902-.004L7 7.703 5.642 9.32l-.903.005a.109.109 0 01-.11-.11c0-.026.01-.05.026-.07l1.779-2.12-1.779-2.118a.11.11 0 01.083-.18l.904.004L7 6.352l1.358-1.619.902-.004c.06 0 .11.048.11.11 0 .025-.01.05-.027.07L7.567 7.028l1.778 2.12c.016.02.026.045.026.07 0 .06-.05.11-.11.11z"
        fill="#F5222D"
      />
    </svg>
  );
}

export default SvgIconNotAccept;
